import * as requestFromServer from "./authCrud";
import {actions} from "./authRedux";
import moment from "moment";
import {
  AuthenticationDetails,
  CognitoUser,
  CognitoUserPool
} from 'amazon-cognito-identity-js';
import data from "../../../../config/cognito";
import config from "../../../../config/common"
const PoolData = data.PoolData;
const userPool = new CognitoUserPool(PoolData);

export const loginWithCognito = code => dispatch => {
  return requestFromServer
    .getAccessToken(code)
    .then(response => {
      const {error, data, status, statusText} = response.data;
      if (error < 0) throw new Error(`${status}: ${statusText}`);

      return dispatch(actions.login(data.token));
    })
    .catch(error => {
      error.clientMessage = "Can't find user";
      dispatch(actions.catchError(error));
    });
};

export const login = ({username, password}) => dispatch => {
  const authenticationData = {
    Username: username,
    Password: password,
  };
  const authenticationDetails = new AuthenticationDetails(authenticationData);
  const userData = {
    Username: username,
    Pool: userPool,
  };
  const cognitoUser = new CognitoUser(userData);
  return new Promise((resolve, reject) => {
    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: function (userSession) {
        const tokens = extractUserSessionTokens(userSession);
        cognitoUser.getUserAttributes((err, result) => {
          if (err) return console.error(err.message || JSON.stringify(err));
          const attributes = transformUserAttributes(result);
          resolve(requestFromServer
            .loginWithTokens({
              userID: attributes.email,
              ...tokens
            })
            .then(response => dispatch(actions.login({
              tokens,
              user: {...cognitoUser, attributes},
              pages: response.data.data.pages
            })))
            .catch(err => console.error(err.message || JSON.stringify(err))))
        });
      },

      onFailure: function (err) {
        const errText = err.message || JSON.stringify(err);
        console.error(errText);
        reject(errText);
      },
    });
  });
};

export const logout = () => dispatch => {
  return requestFromServer
    .logout()
    .catch(err => console.error(err.message || JSON.stringify(err)))
    .finally(() => dispatch(actions.logout()))
};

export const refreshToken = () => dispatch => {
  return requestFromServer
    .refreshToken()
    .then(accessToken => dispatch(actions.registerToken({
      accessToken,
      expire: moment().add(config.expireTimeout).unix()
    })))
};


const extractUserSessionTokens = sessionInfo => {
  const {
    accessToken: {
      jwtToken: accessToken,
      payload: {
        exp: expire,
        sub: uid
      }
    },
    idToken: {
      jwtToken: idToken,
    },
    refreshToken: {
      token: refreshToken,
    }
  } = sessionInfo;

  return {
    uid,
    accessToken,
    idToken,
    refreshToken,
    expire
  }
};

const transformUserAttributes = cognitoAttributes => {
  return cognitoAttributes.reduce((acc, attr) => {
    const {Name, Value} = attr;
    acc[Name] = Value;

    return acc;
  }, {})
};

